var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    top: ((_vm.offsetY * 4 < _vm.size.y * 2 ? _vm.offsetY * 4 : _vm.size.y * 2) + "px"),
    display: ("" + (_vm.offsetY * 2 < _vm.size.y ? 'block' : 'none')),
  }),attrs:{"id":"mainImage"}},[_c('div',{staticClass:"overlay",style:({
      opacity: ("" + (1 - _vm.offsetY / (_vm.size.x / 5) >= 0 ? 1 - _vm.offsetY / (_vm.size.x / 5) : 0)),
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }